import React from 'react'
import Menu, { MenuProps } from 'components/menu'
import { IAggregateTypes } from 'components/spreadsheet/types'
import { ITableViewColumn } from 'types'
import { isValidAggregateTypeForColType } from 'components/spreadsheet/helpers/aggregate'
import { updateColumn } from 'components/spreadsheet/contexts/data/actions'
import { useProject } from 'hooks/useProject'
import { useDataContext } from 'components/spreadsheet/contexts/data/useDataContext'
import { INITIAL_CONTEXT_MENU_STATE } from 'app-constants'
import { MenuHeader, MenuItem, MenuList, MenuSeparator } from 'components/menu/items'
import { Tick } from 'components/icons'

const AggregateMenu: React.FC<MenuProps> = ({ id, menuState, setMenuState, width }) => {
  const { project } = useProject()
  const { spreadsheetData, setSpreadsheetData } = useDataContext()
  const column = spreadsheetData.viewDetails.columns.find(
    (column: ITableViewColumn) => column.publicId === menuState.columnId
  )

  const updateAggregateOption = (column: ITableViewColumn, type: number) => {
    if (menuState.columnId !== undefined) {
      setSpreadsheetData({
        type: 'CHANGE_COLUMN_AGGREGATE',
        columnId: menuState.columnId,
        aggregate: type
      })
      setMenuState(INITIAL_CONTEXT_MENU_STATE)

      if (spreadsheetData.isAdmin) {
        updateColumn(
          project.publicId,
          'aggregate',
          spreadsheetData,
          setSpreadsheetData,
          column.publicId,
          type,
          () => {
            return
          },
          () => {
            return
          }
        )
      }
    }
  }

  // The totals that make sense for the column's type, in the order the menu lists them.
  const choices = column
    ? Object.keys(IAggregateTypes)
        .map((type) => parseInt(type))
        .filter((type) => !isNaN(type) && isValidAggregateTypeForColType(column.kind, type))
    : []

  return (
    <Menu id={id} menuState={menuState} setMenuState={setMenuState} width={width}>
      {column && (
        <>
          <MenuHeader>Footer</MenuHeader>
          <MenuList>
            <div role="menu" aria-label={`Summary for ${column.name}`} className="flex flex-col">
              {/* None on its own, then the totals. */}
              {choices.map((type) => (
                <React.Fragment key={type}>
                  <MenuItem
                    role="menuitemradio"
                    aria-checked={column.aggregate === type}
                    onClick={() => updateAggregateOption(column, type)}
                    end={column.aggregate === type ? <Tick className="size-4 text-body" /> : undefined}
                  >
                    {IAggregateTypes[type]}
                  </MenuItem>
                  {type === IAggregateTypes.None && choices.length > 1 && <MenuSeparator />}
                </React.Fragment>
              ))}
            </div>
          </MenuList>
        </>
      )}
    </Menu>
  )
}

export default AggregateMenu
